package kz.dentalcrm.app.screens.positions.list

import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.domain.PositionsRepository
import kz.dentalcrm.app.screens.positions.list.mvi.PositionsViewEvent
import kz.dentalcrm.app.screens.positions.list.mvi.PositionsViewSideEffect
import kz.dentalcrm.app.screens.positions.list.mvi.PositionsViewState
import org.koin.core.component.inject

class PositionsViewModel :
    BaseStateViewModel<PositionsViewEvent, PositionsViewState, PositionsViewSideEffect>() {

    private val positionsRepository: PositionsRepository by inject()

    override fun setInitialState() = PositionsViewState()

    override fun handleEvents(event: PositionsViewEvent) {
        when (event) {
            is PositionsViewEvent.Search -> {
                setState { copy(search = event.query) }
                loadPositions()
            }
            PositionsViewEvent.Reload -> {
                loadPositions()
            }
            is PositionsViewEvent.EditPosition -> {
                setEffect {
                    PositionsViewSideEffect.ShowEditPosition(
                        position = event.position
                    )
                }
            }
            is PositionsViewEvent.DeletePosition -> {
                setState {
                    copy(positions = positions.filter { it.id != event.id }.toPersistentList())
                }
            }
        }
    }

    private fun loadPositions() {
        setState {
            copy(
                screenState = PositionsViewState.ScreenState.Loading
            )
        }
        launch(Dispatchers.Default) {
            positionsRepository.getPositions().stateHandle(
                onError = { _, message ->
                    setState {
                        copy(
                            screenState = PositionsViewState.ScreenState.Error(
                                text = message
                            )
                        )
                    }
                },
                onFailure = {
                    setState {
                        copy(
                            screenState = PositionsViewState.ScreenState.Error(
                                text = "Произошла неожиданная ошибка"
                            )
                        )
                    }
                },
                onSuccess = { data ->
                    val filtered = if (viewState.value.search.isNotEmpty()) {
                        data?.filter { it.name?.contains(viewState.value.search, ignoreCase = true) == true }
                    } else {
                        data
                    }
                    setState {
                        copy(
                            positions = (filtered ?: emptyList()).toPersistentList(),
                            screenState = PositionsViewState.ScreenState.Idle
                        )
                    }
                }
            )
        }
    }

    init {
        loadPositions()
    }
}
